import Endpoints from "@/config/ApiEndpoints.js";
import Axios from "axios";
import { required, email} from "vuelidate/lib/validators";

const file_size_validation = (value, vm) => {
  if (!value || !value.size) {
    return true;
  }
  let file = value;
  return file.size < 1048576;
};
const image_type_validation = (value, vm) => {
  if (!value || !value.size) {
    return true;
  }
  let file = value;
  if (
    file.type == "image/svg+xml" ||
    file.type == "image/jpeg" ||
    file.type == "image/gif" ||
    file.type == "image/png"
  ) {
    return true;
  } else {
    return false;
  }
};
  
  export default {
    components: {
    },
    data() {
      return {
        ShowLoader: false,
        Saving: false,
        submitted: false,
        SearchKey: "",
        UserId:0,
        ProfileImage:"",
        Branches: [],
        Roles: [],
        RoleData: [],
        RoleHeading: "",
        Permissions: "",
        EditUser: {
          forename: "",
          surname: "",
          email: "",
          phone: "",
          profile_image: "",
          role_id: "",
          branch_ids: [],
          is_2fa_enabled: false,
        },
      };
    },
    validations: {
      EditUser: {
        forename: { required },
        surname: { required },
        email: { required, email },
        phone: { required },
        profile_image: { file_size_validation, image_type_validation },
      },
    },
    mounted() {
      document.title = pbx_SiteTitle + " - User Add";
      var UserData = JSON.parse(localStorage.getItem("User"));
      this.UserId = UserData.id;
      this.GetUserDetail();
      this.GetBranches();
      this.GetRoles();
      this.GetRolePermissions();
    },

    methods: {
      Set2FA(type){
        this.EditUser.is_2fa_enabled = type;
      },
      GetBranches() {
        var obj = { token: localStorage.getItem("token"), select_branch: true };
        Axios.post(Endpoints.Branch.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Branches = Response.data.records;
          }
        });
      },
      GetRoles() {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Roles.List, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Roles = Response.data.records;
            
          }
        });
      },
      GetRolePermissions() {
        Axios.post(Endpoints.Roles.Permission,  {
          token: localStorage.getItem("token"),
          id: this.UserId,
        }).then((Response) => {
          if (Response?.data?.success) {
            this.RoleData = Response.data.record;
            if(this.RoleData.role){
              this.RoleHeading = this.RoleData.role.title;
              this.Permissions = this.RoleData.role.permissions;
            }
          }
        });
      },
      GetUserDetail() {
        this.ShowLoader = true;
        Axios.post(Endpoints.User.Get, {
          token: localStorage.getItem("token"),
          id: this.UserId,
        }).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.EditUser = Response.data.record;
            setTimeout(() => {
              this.GetProfileImage(this.EditUser.profile_image);
            }, 1000);
           
          }
        });
      },
      imageFileChanged(event) {
        var files = event.target.files || event.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.EditUser.profile_image = files[0];
        var output = document.querySelector(".icon__preview");
        output.src = URL.createObjectURL(files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src);
        };
      },
      UpdateUser() {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.Saving = true;
        Axios.post(Endpoints.User.Update, {
          token: localStorage.getItem("token"),
          ...this.EditUser,
        }).then((Response) => {
          if (Response?.data?.success) {
            this.UpdateProfileImage(Response.data.last_id);
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response?.data?.message || "Something went wrong",
              icon: "error",
              confirmButtonText: "Close",
            });
            this.Saving = false;
          }
        });
      },
      UpdateProfileImage(id) {
        var LogoFormData = new FormData();
        if (this.$refs.ProfileImageFile.files[0]) {
          LogoFormData.append("storage_type", "CFU");
          LogoFormData.append("token", localStorage.getItem("token"));
          LogoFormData.append("file", this.$refs.ProfileImageFile.files[0]);
          LogoFormData.append(
            "company_id",
            this.EditUser.company_id
          );
          LogoFormData.append("user_id", id);
          Axios.post(Endpoints.Helper.File.Upload, LogoFormData).then(
            (UploadResponse) => {
              var UploadData = UploadResponse.data;
              if (UploadData.success === true) {
                Axios.post(Endpoints.User.Profile.Image.Set, {
                  token: localStorage.getItem("token"),
                  profile_image: UploadData.file,
                  id: id,
                }).then((SetResponse) => {
                  this.EditUser.profile_image = UploadData.file;
                  localStorage.setItem(
                    "User",
                    JSON.stringify(this.EditUser)
                  );
                  this.Saving = false;
                  this.$swal.fire(
                    "Your Profile Updated Successfully",
                    "",
                    "success"
                  ).then(() => {
                    this.$router.go();
                  });
                });
              }
            }
          );
        } else {
          localStorage.setItem(
            "User",
            JSON.stringify(this.EditUser)
          );
          this.Saving = false;
          this.$swal.fire("Your Profile Updated Successfully", "", "success").then(
            () => {
              this.$router.go();
            }
          );
        }
      },
      GetProfileImage(profileImage) {
        Axios.post(Endpoints.Helper.File.Get, {
          token: localStorage.getItem("token"),
          file: profileImage,
        }).then((FileGetResponse) => {
          var FileData = FileGetResponse.data;
          if (FileData.success === true) {
            this.ProfileImage = FileData.file;
            this.$refs.editProfileImagePreview.src = FileData.file;
          }
        });
      },
    },
  };